import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { showErrorMessage, showSuccessMessage } from "helpers/toastMessage";
import { axios } from "services/middleware";
import { AppDispatch } from "store";
import { getStripeSubscription, getSubscriptionHistory } from "store/userSetting/actions";

const useStripeScript = ({ plan, planAmount }: { plan: string; planAmount: string }) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://checkout.stripe.com/checkout.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleStripeCheckout = () => {
    const handler = (window as any).StripeCheckout.configure({
      key: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
      image: "https://app.staging.comfreight.com/public/image/icon/ComFreightLogo.png",
      locale: "auto",
      token: async (token: any) => {
        try {
          await axios.post("/stripe/subscription/", {
            stripe_token: token.id,
            plan: plan,
            is_legacy: false
          });
          dispatch(getStripeSubscription());
          dispatch(getSubscriptionHistory());
          showSuccessMessage("Subscription Success.");
        } catch {
          showErrorMessage("Subscription Error.");
        }
      }
    });

    // Open Checkout with further options
    handler.open({
      name: "ComFreight",
      description: "Freight Marketplace",
      currency: "usd",
      amount: Number(planAmount) * 100,
      panelLabel: "Pay",
      allowRememberMe: false
    });
  };

  return { handleStripeCheckout: handleStripeCheckout };
};

export default useStripeScript;
